import { ECOFLOW_MEDIA_HOSTS } from 'eco-design-micro/utils-base/mediaHosts';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

declare global {
    interface Window {
        /** consentmanager 自动拦截的忽略域名列表，必须在 autoblocking 脚本执行前赋值才生效 */
        cmp_block_ignoredomains?: string[];
    }
}

export default function OneTrustCookie({ locale = '', handleLoad }: { locale: string; handleLoad?: () => void }) {
    // if (typeof window !== 'undefined' && window.location.href.indexOf('http://10.20.101.85:3005/') > -1) return <Helmet></Helmet>;

    useEffect(() => {
        if (['it', 'us', 'nl', 'uk', 'de', 'fr', 'es', 'eu', 'pl'].includes(locale)) {
            const idMap = {
                it: '4b4fbd25c2d66',
                us: '95bf16c722cdd',
                nl: 'dd55e41a42878',
                uk: 'be55246ac219d',
                de: '6d1da74a725b3',
                fr: 'fe8da7da22409',
                es: '5c365b5bb26b2',
                eu: 'f3f80b7b42193',
                pl: 'a7ba7bfb32489',
            };
            // 自家媒体域名不存在对应的 vendor，被自动拦截后不会再放行，必须在脚本执行前排除掉
            window.cmp_block_ignoredomains = Array.from(new Set([...(window.cmp_block_ignoredomains ?? []), ...ECOFLOW_MEDIA_HOSTS]));

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.dataset.cmpAb = '1';
            script.src = `https://cdn.consentmanager.net/delivery/autoblocking/${idMap[locale as keyof typeof idMap]}.js`;
            script.dataset.cmpHost = 'c.delivery.consentmanager.net';
            script.dataset.cmpCdn = 'cdn.consentmanager.net';
            script.dataset.cmpCodesrc = '0';

            let fallbackCalled = false;
            const callHandleLoad = () => {
                if (!fallbackCalled) {
                    fallbackCalled = true;
                    handleLoad?.();
                }
            };

            script.onload = callHandleLoad;
            // consentmanager CDN 加载失败时兜底
            script.onerror = callHandleLoad;
            // consentmanager CDN 超时兜底（8秒）
            const fallbackTimer = setTimeout(callHandleLoad, 8000);

            document.head.appendChild(script);

            return () => {
                clearTimeout(fallbackTimer);
                document.head.removeChild(script);
            };
        }
    }, [locale, handleLoad]);
    return (
        <Helmet>
            {/* {locale === 'eu' && (
                <script type="text/javascript" src="https://cdn-apac.onetrust.com/consent/4074621e-35d2-4229-a8da-da5e8d27f74e/OtAutoBlock.js"></script>
            )}
            {locale === 'eu' && (
                <script
                    src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
                    type="text/javascript"
                    charset="UTF-8"
                    data-domain-script="4074621e-35d2-4229-a8da-da5e8d27f74e"
                ></script>
            )} */}
            {/* {locale === 'de' && (
                <script type="text/javascript" src="https://cdn-apac.onetrust.com/consent/afc32dfc-3867-48ae-b646-349866e97417/OtAutoBlock.js"></script>
            )} */}
            {/* {locale === 'de' && (
                <script
                    src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
                    type="text/javascript"
                    charset="UTF-8"
                    data-domain-script="afc32dfc-3867-48ae-b646-349866e97417"
                ></script>
            )} */}
            {/* {locale === 'fr' && (
                <script type="text/javascript" src="https://cdn-apac.onetrust.com/consent/82015cc0-5e02-43ab-b816-a62b6175e99a/OtAutoBlock.js"></script>
            )} */}
            {/* {locale === 'fr' && (
                <script
                    src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
                    type="text/javascript"
                    charset="UTF-8"
                    data-domain-script="82015cc0-5e02-43ab-b816-a62b6175e99a"
                ></script>
            )} */}
            {/* {locale === 'uk' && (
                <script type="text/javascript" src="https://cdn-apac.onetrust.com/consent/5638b0ec-a07b-4f6f-b1a7-d27e840f0e12/OtAutoBlock.js"></script>
            )}
            {locale === 'uk' && (
                <script
                    src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
                    type="text/javascript"
                    charset="UTF-8"
                    data-domain-script="5638b0ec-a07b-4f6f-b1a7-d27e840f0e12"
                ></script>
            )} */}

            {/* {locale === 'it' && (
                <script
                    type="text/javascript"
                    data-cmp-ab="1"
                    src="https://cdn.consentmanager.net/delivery/autoblocking/4b4fbd25c2d66.js"
                    data-cmp-host="c.delivery.consentmanager.net"
                    data-cmp-cdn="cdn.consentmanager.net"
                    data-cmp-codesrc="0"
                ></script>
            )} */}

            {/* {locale === 'it' && (
                <script type="text/javascript" src="https://cdn-apac.onetrust.com/consent/c41c15e6-d939-47eb-9b75-e033fb47dc5e/OtAutoBlock.js"></script>
            )}
            {locale === 'it' && (
                <script
                    src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
                    type="text/javascript"
                    charset="UTF-8"
                    data-domain-script="c41c15e6-d939-47eb-9b75-e033fb47dc5e"
                ></script>
            )} */}
            {/* {locale === 'es' && (
                <script type="text/javascript" src="https://cdn-apac.onetrust.com/consent/4f0236c5-f9ba-42e0-9ea4-1087d7fa4a3d/OtAutoBlock.js"></script>
            )}
            {locale === 'es' && (
                <script
                    src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
                    type="text/javascript"
                    charset="UTF-8"
                    data-domain-script="4f0236c5-f9ba-42e0-9ea4-1087d7fa4a3d"
                ></script>
            )} */}
        </Helmet>
    );
}
